import React from 'react'

const RegisterSuccess = () => {
    return (
        <div>

        </div>
    )
}

export default RegisterSuccess
